export default "__VITE_ASSET__DJYXgfq7__"